import navLogo from "../Assets/Logos/navLogo.png";
import homeProprty1 from "../Assets/Property/homeProprty1.jpg";
import homeProprty2 from "../Assets/Property/homeProprty2.jpg";
import homeProprty3 from "../Assets/Property/homeProprty3.jpg";
import bannerProprty from "../Assets/Property/banner_proprty.jpg";
import chandan_sekhar_residency from "../Assets/Property/CHANDAN-SEKHAR-Residency.png";
import chandra_sekhar_pride from "../Assets/Property/Chandra-Sekhar-PRIDE.png";
import sekhar_mahesh_pride from "../Assets/Property/SEKHAR-MAHESH-PRIDE.png";
import sekhar_ratna from "../Assets/Property/Sekhar-RATNA.png";
import faqBanner from "../Assets/Images/faqBanner.jpg";
import profile1 from "../Assets/Images/profile1.jpg";
import profile2 from "../Assets/Images/profile2.jpg";
import profile3 from "../Assets/Images/profile3.jpg";
import profile4 from "../Assets/Images/profile4.jpg";
import getInTouchBanner from "../Assets/Images/getInTouchBanner.jpg";

export const assets = {
  getInTouchBanner,
  navLogo,
  homeProprty1,
  homeProprty2,
  homeProprty3,
  bannerProprty,
  chandan_sekhar_residency,
  chandra_sekhar_pride,
  sekhar_mahesh_pride,
  sekhar_ratna,
  faqBanner,
  profile1,
  profile2,
  profile3,
  profile4,
};
